import { Injectable } from '@angular/core'
import { Route, ActivatedRouteSnapshot, CanLoad, CanActivate, Router } from '@angular/router';
import { AuthService } from './auth.service';
import { LoginService } from 'src/app/pages/login/login.service';
import { AppService } from 'src/app/server/app.service';

@Injectable()
export class AuthGuard implements CanLoad, CanActivate {

    constructor(
        private appService: AppService,
        private auth: AuthService,
        private loginService: LoginService,
        private router: Router
    ) {

    }

    canLoad(route: Route): boolean {
        return this.checkAuthentication(route.path)
    }

    canActivate(activatedRoute: ActivatedRouteSnapshot): boolean {
        return this.checkAuthentication(activatedRoute.routeConfig.path)
    }

    checkAuthentication(path: string): boolean {
        let _return: boolean = false

        new Promise((resolve, reject) => {

            if (!this.auth.loggedIn) {
                this.loginService.handleLogin(`/${path}`)
                resolve()
            }

            this.appService.getUser().subscribe(
                user => {
                    this.appService.getUserMenu(0).subscribe(items => {
                        if (items) {
                            let item = items.filter(item => item.route == `/${path}`)
                            if (item.length > 0) {
                                _return = true
                                resolve()
                            }
                            resolve()
                        } else {
                            _return = false
                            resolve()
                        }
                    })

                }
            )

        }).then((res) => {
            if (!_return) {
                this.router.navigate(["/home"])
                return _return
            }
        }).catch((err) => {
            console.log('Erro', err)
            return _return
        });

        return true
    }


}